import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff86bd16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-mb-2 p-mt-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold" }, "รายการของแถม", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-ml-auto" }, "-", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mb-2 p-mt-3 p-d-flex p-jc-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold" }, "รายการของแถม")
], -1))
const _hoisted_6 = { class: "p-d-flex p-jc-between p-mt-3" }
const _hoisted_7 = {
  key: 0,
  class: "p-error f-size-14"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "p-mt-2 p-p-6 shadow bg-color-secondary rounded p-d-flex"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-m-auto" }, "กรุณาเลือกของแถม", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "p-mt-2 p-p-3 shadow bg-color-secondary rounded p-d-flex"
}
const _hoisted_14 = { class: "p-my-auto product-image-wrap" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "p-ml-2 w-100" }
const _hoisted_17 = { class: "p-d-flex" }
const _hoisted_18 = { class: "line-clamp" }
const _hoisted_19 = { class: "p-ml-auto" }
const _hoisted_20 = { class: "f-size-14 text-gray-1" }
const _hoisted_21 = { class: "p-d-flex p-mt-4" }
const _hoisted_22 = { class: "f-size-14 text-gray-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-ml-auto f-size-14" }, "ฟรี", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalFreeProduct = _resolveComponent("ModalFreeProduct")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.freeProductsDisplay.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.freeProductsDisplay.length !== 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freeProductsDisplay, (free, findex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "",
              key: 'promotion_' + findex
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, "โปรโมชั่น " + _toDisplayString(free.promotionName), 1),
                  (free.poductSelectedCount < free.limitProduct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " กรุณาเลือกของแถมให้ครบ " + _toDisplayString(free.limitProduct) + " ชิ้น ", 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createElementVNode("u", {
                          class: "pointer",
                          onClick: ($event: any) => (_ctx.onpenModalFreeProduct(free))
                        }, "เลือกของแถม", 8, _hoisted_9)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (free.poductSelectedCount == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                : _createCommentVNode("", true),
              (free.poductSelectedCount !== 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(free.products, (freeProduct, fpindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'freeproduct_' + fpindex
                    }, [
                      (freeProduct.selected)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("img", {
                                src: freeProduct.imageUrl,
                                class: "product-image"
                              }, null, 8, _hoisted_15)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(freeProduct.name), 1),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(freeProduct.quantity), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(freeProduct.barcode), 1),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$filters.formatNumber(freeProduct.price)) + " x " + _toDisplayString(freeProduct.quantity), 1),
                                _hoisted_23
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalFreeProduct, {
      ref: "modalFreeProduct",
      selectedPromotion: _ctx.selectedPromotion,
      key: _ctx.modalKey,
      onOnSubmitFreeProduct: _ctx.onSubmitFreeProduct
    }, null, 8, ["selectedPromotion", "onOnSubmitFreeProduct"])
  ]))
}